import { render, staticRenderFns } from "./inpatientDeta.vue?vue&type=template&id=04f2642f&scoped=true"
import script from "./inpatientDeta.vue?vue&type=script&lang=js"
export * from "./inpatientDeta.vue?vue&type=script&lang=js"
import style0 from "./inpatientDeta.vue?vue&type=style&index=0&id=04f2642f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2642f",
  null
  
)

export default component.exports